import * as React from 'react';
const SvgSats = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={168}
    height={52}
    fill="currentColor"
  >
    <path d="M9.6 36.2.6 43c3.4 4.8 9.4 8.4 17.8 8.4C30.8 51.4 38 44 38 34.2c0-5-3-8-6.2-10.8l-3.2-3c-2-1.8-3-3.2-3-5 0-2.4 1.6-4.6 5.4-4.6 2.6 0 5.2 1 7.6 3.6l9-6.8c-2.2-3.4-7.4-7-15.4-7-10.8 0-18.8 7.2-18.8 16.6 0 4.6 2.6 7.8 6 10.8l3.2 3c2.2 2 3.2 3.2 3.2 5 0 2.4-1.8 5-6.6 5-3.8 0-7.2-1.8-9.6-4.8m119.6 0-9 6.8c3.2 4.8 9.4 8.4 17.8 8.4 12.4 0 19.6-7.4 19.6-17.2 0-5-3-8-6.2-10.8l-3.2-3c-2-1.8-3-3.2-3-5 0-2.4 1.6-4.6 5.4-4.6 2.6 0 5.2 1 7.6 3.6l9-6.8c-2.2-3.4-7.4-7-15.4-7C141 .6 133 7.8 133 17.2c0 4.6 2.6 7.8 6 10.8l3.2 3c2.2 2 3.2 3.2 3.2 5 0 2.4-1.8 5-6.6 5-3.8 0-7.2-1.8-9.6-4.8m-1.6-24.4H116l-10.8 38.4h-12L104 11.8H91.6l3-10.4h36.2zm-44 38.6V1.6H67L38.2 50.4H51l5.6-10.2H73v10.2zM73 11v18.8H62.4z" />
  </svg>
);
export default SvgSats;
